export const IMPLICIT_CAD_SCHEMA = "implicit.js/0.1.0";
export const IMPLICIT_CAD_KIND = "implicit";
export const IMPLICIT_CAD_EXTENSIONS = Object.freeze([".implicit.js", ".implicit.mjs"]);

export const IMPLICIT_SCHEMA = IMPLICIT_CAD_SCHEMA;
export const IMPLICIT_KIND = IMPLICIT_CAD_KIND;
export const IMPLICIT_EXTENSIONS = IMPLICIT_CAD_EXTENSIONS;
